var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF2746"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#940030"
    },
    d: "M505.446,313.811L358.555,166.921L131,393.04l118.882,118.882c2.034,0.048,4.072,0.078,6.118,0.078 C377.504,512,479.237,427.351,505.446,313.811z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "300.23,108.596 131,108.596 131,393.04 358.555,393.04 358.555,166.921 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "358.555,166.921 300.23,108.596 238.187,108.596 238.187,393.04 358.555,393.04 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4C4C4"
    },
    points: "300.23,166.921 358.555,166.921 300.23,108.596 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M206.734,421.669L206.734,421.669c7.825,7.825,20.511,7.825,28.336,0l83.877-83.877 c7.825-7.825,7.825-20.511,0-28.336l0,0c-7.825-7.825-20.511-7.825-28.336,0l-83.877,83.877 C198.909,401.158,198.909,413.844,206.734,421.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A0A33"
    },
    d: "M318.473,309.029L206.305,421.197c0.147,0.155,0.276,0.321,0.428,0.474 c7.825,7.825,20.511,7.825,28.336,0l83.877-83.877c7.825-7.825,7.825-20.511,0-28.336 C318.795,309.305,318.63,309.176,318.473,309.029z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 346.712,
    cy: 281.686,
    r: 82.553
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M405.09,223.315c-0.152-0.152-0.31-0.29-0.462-0.44L287.904,339.599 c0.15,0.152,0.288,0.31,0.44,0.462c32.239,32.239,84.508,32.239,116.746,0S437.329,255.552,405.09,223.315z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#71E2EF"
    },
    cx: 346.712,
    cy: 281.686,
    r: 61.714
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38C6D9"
    },
    d: "M389.892,237.609l-87.254,87.254c0.15,0.152,0.288,0.31,0.44,0.462c24.1,24.1,63.176,24.1,87.276,0 c24.1-24.1,24.1-63.176,0-87.276C390.204,237.897,390.046,237.759,389.892,237.609z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c0fd1fadc6b26cdf9a9d34167c9fcbef.svg";
export { ForwardRef as ReactComponent };